import 'animate.css';

import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';

import { useDriversState } from '../hooks/useDriversState';

export const DRIVERS_LAYOUT_ID = `DRIVERS_LAYOUT`;

const DriversLayoutContainer = styled.div`
  margin-bottom: env(safe-area-inset-bottom);

  // This is needed for allow scroll in webapp (start)
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  // This is needed for allow scroll in webapp (end)

  @media (min-width: 600px) {
    width: 440px;
    height: 956px;
    min-height: auto;
    margin: auto;
    margin-top: 50px;
    -webkit-box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.08);
    box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.08);
    position: relative;
    z-index: 1;
    border-radius: 36px;
  }
  @media (min-height: 800px) and (min-width: 600px) {
    height: 800px;
  }
  @media (min-height: 1000px) and (min-width: 600px) {
    height: 956px;
  }
`;

interface DriversLayoutProps {
  id?: string;
  style?: React.CSSProperties;
  translationsLoaded?: boolean;
}

export const DriversLayout = ({
  id = DRIVERS_LAYOUT_ID,
  children,
  style = {},
}: React.PropsWithChildren<DriversLayoutProps>) => {
  const layoutContainerRef = createRef<HTMLDivElement>();
  const { storeDriverState } = useDriversState();

  useEffect(() => {
    if (layoutContainerRef.current) {
      // Get the height of the layout container
      const height = layoutContainerRef.current.clientHeight;
      const width = layoutContainerRef.current.clientWidth;
      const offsetTop = layoutContainerRef.current.offsetTop;
      const offsetLeft = layoutContainerRef.current.offsetLeft;
      storeDriverState({ height, width, offsetTop, offsetLeft });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutContainerRef.current]);

  return (
    <DriversLayoutContainer id={id} ref={layoutContainerRef} style={style}>
      {children}
    </DriversLayoutContainer>
  );
};
